import React from 'react';
import { IconSortCaret } from '../icons';
import Styles from './custom-bootstrap-table.scss';
const SortCaret = (order, column) => {
    if (!order)
        return (React.createElement("span", { className: Styles.wrap },
            React.createElement(IconSortCaret, { color1: "#BBBBBB", color2: "#BBBBBB" })));
    else if (order === 'asc')
        return (React.createElement("span", { className: Styles.wrap },
            React.createElement(IconSortCaret, { color1: "#FFA800", color2: "#BBBBBB" })));
    else if (order === 'desc')
        return (React.createElement("span", { className: Styles.wrap },
            React.createElement(IconSortCaret, { color1: "#BBBBBB", color2: "#FFA800" })));
    return null;
};
export default SortCaret;
